// extracted by mini-css-extract-plugin
export var cell = "_6s-4";
export var headerCell = "_6s-2";
export var rowHeader = "_6s-3";
export var table = "_6s-1";
export var tableContainer = "_6s-0";